var exports = {
  "y": "x04b3a21e--6e5aef--collapsed",
  "l": "x04b3a21e--6e5aef--expandable",
};

module.exports = exports;
